import { utcToZonedTime } from 'date-fns-tz';

export default function (date = new Date(), timezone = null) {
    return utcToZonedTime(date, timezone || window.AppConfig.timezone || 'America/Los_Angeles');
}
